<div class="other-wrapper">
  <div class="hr"></div>
  <div class="other-method-text">ou</div>
</div>
